import { render } from "./VideoChatWidget.vue?vue&type=template&id=1d6f20b1"
import script from "./VideoChatWidget.vue?vue&type=script&lang=js"
export * from "./VideoChatWidget.vue?vue&type=script&lang=js"

import "./VideoChatWidget.vue?vue&type=style&index=0&id=1d6f20b1&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__